import { render, staticRenderFns } from "./match_simulator_new.vue?vue&type=template&id=3fbf271c&"
import script from "./match_simulator_new.vue?vue&type=script&lang=js&"
export * from "./match_simulator_new.vue?vue&type=script&lang=js&"
import style0 from "./match_simulator_new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports